angular.module('storefrontApp')

.component('vcPrice', {
    templateUrl: "themes/assets/js/products-list/price.tpl.html",
    bindings: {
        price: '='
    }
});
